// tslint:disable: jsx-no-lambda
import React, { FC } from 'react';
import { getTrackBackground, Range } from 'react-range';

interface IProps {
  min: number;
  max: number;
  value: number;
  step: number;
  onChange(value: number): void;
}

export const InputRange: FC<IProps> = ({ min, max, value, step, onChange }) => {
  const handleChange = (values: Array<number>) => onChange(values[0]);

  return (
    <Range
      step={step}
      min={min}
      max={max}
      values={[value]}
      onChange={handleChange}
      renderTrack={({ props, children }) => (
        <div
          {...props}
          style={{
            ...props.style,
            background: getTrackBackground({
              colors: ['#72659F', '#d5d5d5'],
              max,
              min,
              values: [value],
            }),
            height: '3px',
            margin: '0 10px',
            width: '135px',
          }}
        >
          {children}
        </div>
      )}
      renderThumb={({ props }) => (
        <div
          {...props}
          style={{
            ...props.style,
            backgroundColor: '#72659F',
            borderRadius: '100%',
            height: '12px',
            width: '12px',
          }}
        />
      )}
    />
  );
};
